import React, { Fragment } from "react";
import notificationSound from "../img/warning.mp3";

class WarningIcon extends React.Component {
  audio = new Audio(notificationSound);

  componentDidUpdate(oldProps) {
    if (
      oldProps.warning !== this.props.warning &&
      oldProps.warning < this.props.warning
    ) {
      this.audio.play();
    }
  }
  render() {
    return (
      <Fragment>
        {!!this.props.warning ? (
          <div
            style={{
              borderRadius: "50%",
              height: this.props.size,
              width: this.props.size,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "red",
              color: "#FFE533",
              boxShadow: "2px 2px 2px 0px rgba(0,0,0,0.4)",
              marginTop: -10,
              marginRight: -2,
            }}
          >
            <div style={{ color: "yellow" }}>!</div>
          </div>
        ) : (
          <div style={{ display: "none" }}></div>
        )}
      </Fragment>
    );
  }
}

export default WarningIcon;
